<template>
  <!-- tooltip เฉพาะตอนมีเหตุผลให้บอก — chip ที่ hover แล้วขึ้นกล่องเปล่าอ่านเหมือนบั๊ก -->
  <v-tooltip v-if="reason" location="top" :text="reason">
    <template #activator="{ props }">
      <v-chip v-bind="props" size="x-small" color="grey" variant="tonal" label prepend-icon="mdi-flask-outline" class="qa-mock-chip">{{ text }}</v-chip>
    </template>
  </v-tooltip>
  <v-chip v-else size="x-small" color="grey" variant="tonal" label prepend-icon="mdi-flask-outline" class="qa-mock-chip">{{ text }}</v-chip>
</template>

<script>
/**
 * ป้ายกำกับ "ตรงนี้ยังไม่ใช่ของจริง"
 *
 * Q10 ต่อ Overview / Agents / Investigations เข้าข้อมูลจริงหมดแล้ว — และนั่นคือเหตุผล
 * ที่ต้องมีป้ายนี้: พอทั้งหน้าเป็นของจริง ช่องที่ยังไม่มีแหล่งข้อมูล (compliance gate
 * ที่ยังไม่เปิดตรวจ · ประวัติการแก้ค่าตั้ง · สรุปการสนทนา) จะถูกอ่านเป็นของจริงไปด้วย
 * โดยอัตโนมัติ ทั้งที่มันเป็นค่าคงที่/ตัวอย่าง — ความเข้าใจผิดชนิดที่ไม่มีใครจับได้
 *
 * ⚠️ ไม่ใช้แบนเนอร์รวมหัวหน้าจอโดยตั้งใจ (ของเดิมใน QaPageShell ถูกถอดออกรอบนี้) —
 *    แบนเนอร์ที่ขึ้นเหมือนกันทุกหน้าไม่ว่าหน้านั้นจริงหรือจำลอง คนอ่านสองครั้งแล้วเลิกอ่าน
 *    ป้ายต้องอยู่ **ติดกับตัวเลขที่มันเตือน** ถึงจะยังทำงานอยู่
 * ⚠️ เทาและเล็กโดยตั้งใจ — นี่คือหมายเหตุ ไม่ใช่สัญญาณอันตราย · ถ้าทำให้แดง/ใหญ่
 *    มันจะแย่งสายตาไปจากเคสที่ต้องตรวจจริง ๆ ซึ่งอยู่บนหน้าเดียวกัน
 */
export default {
  name: 'QaMockChip',
  props: {
    text: { type: String, default: 'ข้อมูลจำลอง' },
    /** เหตุผลที่ยังไม่จริง — ขึ้นเป็น tooltip · ว่างได้ถ้าคำบนป้ายอธิบายตัวเองครบแล้ว */
    reason: { type: String, default: '' },
  },
};
</script>

<style scoped>
.qa-mock-chip {
  /* เคอร์เซอร์ help บอกว่ามีอะไรให้อ่านเพิ่มตอน hover — ไม่งั้น tooltip แทบไม่มีใครเจอ */
  cursor: help;
}
</style>
